import { useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { FaRegEdit } from "react-icons/fa";
import Swal from "sweetalert2";
import { BiReset } from "react-icons/bi";
import { plateformSettingServices } from "../../../APIServices/PasswordManagement/plateformSettingServices";

const ExtensionSettings = ({ auth, getSinglePlateformSettings, plateformSettings }) => {
  const [extensionSettings, setExtensionSettings] = useState("");
  const [loader, setLoader] = useState(false);

  const addUpdatePlateformSettings = async (type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${type} extension setting?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let userData = {};
        userData.extensionSettings = type === "update" ? extensionSettings : "activeAccountItems";
        let data = await plateformSettingServices.addUpdatePlateformSettings(auth, userData);
        if (data?.statusCode === 200) {
          getSinglePlateformSettings();
        }
        setLoader(false);
      }
    });
  };

  useEffect(() => {
    if (plateformSettings) {
      setExtensionSettings(plateformSettings?.settings?.extensionSettings || "activeAccountItems");
    }
  }, [plateformSettings]);
  return (
    <>
      <div className="w-50 m-auto pb-1 pt-3 hstack justify-content-between">
        <h5 className="fw-bold mb-1">Extension Settings</h5>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 48px)" }}>
        <div className="w-50 m-auto py-3">
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <Form.Group className="mb-2">
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Item List Type{" "}
                  <abbr className="text-danger" title="Require">
                    *
                  </abbr>
                </Form.Label>
                <Form.Select
                  className="interactive-input rounded-1"
                  style={{ fontSize: 12, padding: "6px 15px" }}
                  onChange={(e) => setExtensionSettings(e.target.value)}
                  value={extensionSettings}
                >
                  <option value="">Select Item List Type</option>
                  <option value="activeAccountItems">Active Account Items</option>
                  <option value="allAccountItems">All Account Items</option>
                </Form.Select>
              </Form.Group>
              <div className="hstack justify-content-end gap-2">
                {(plateformSettings?.settings?.extensionSettings != "activeAccountItems") &&
                  <Button
                    disabled={loader}
                    onClick={() => addUpdatePlateformSettings("reset")}
                    variant="outline-danger"
                    style={{ fontSize: 13 }}
                    title="Reset"
                    className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                  >
                    <BiReset /> Reset
                  </Button>
                }
                <Button
                  disabled={loader}
                  onClick={() => addUpdatePlateformSettings("update")}
                  variant="outline-primary"
                  style={{ fontSize: 13 }}
                  title="Update"
                  className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                >
                  <FaRegEdit /> Update
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ExtensionSettings;
